var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381 237.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-14.9,263.3 c20.2-11.7,45.5-17.6,65.8-29c14.9-8.6,38.2-22,42.6-38.5c6.6-17,11-36.4,26.1-48.2c18.5-17,49-27.3,63.6-48.5 c15.8-19.7,12.6-48,30.9-65.8c9.3-8.8,28-27.4,35.9-34.8l-81.8-6.7C106.7-3.5,45.1-4.8-16.4,0c0.5,38.9,1.3,84.4,2.4,124.3 c0.7,24.5,1.5,48.8,2.4,72.9C-12.8,219.2-13.9,241.3-14.9,263.3z",
    fill: "#f0deb1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cover_svg__auth_col_pink",
    d: "M177.3-87.9l0.1,188.6l-26.7-14.4v-187L177.3-87.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cover_svg__auth_col_purple",
    d: "M43.2,172.4L43.3,361l-26.7-14.4v-187L43.2,172.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101,75.4C93.4,81.9,90.8,93,83,99.3c-6.7,5.4-15.9,6.3-24.5,6.9",
    fill: "none"
  })));
}

export default SvgCover;